var _Path, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgCatBadge = function SvgCatBadge(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#cat-badge_svg__a)",
    d: "M2.895 8.999c-.213-.925.862-1.598 1.601-1.003L6.612 9.7a1 1 0 0 0 1.496-.285l2.772-4.883a1 1 0 0 1 1.74 0l2.772 4.883a1 1 0 0 0 1.496.285l2.116-1.704c.739-.595 1.813.078 1.601 1.003l-2.344 10.225a1 1 0 0 1-.974.776H6.213a1 1 0 0 1-.974-.776z"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cat-badge_svg__a",
    x1: 6.287,
    x2: 8.047,
    y1: 3,
    y2: 19.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FCF17B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E19010"
  })))));
};
export default SvgCatBadge;